import { useRef } from 'react';
const uniqueId = (function () {
    let num = 0;
    return function (prefix) {
        num += 1;
        return `${prefix}-${num}`;
    };
})();
export const useUniqueId = (prefix) => {
    const idRef = useRef(uniqueId(prefix));
    return idRef.current;
};
